export const LOCALES = ['en', 'us', 'es', 'de'] as const
export const DEFAULT_LOCALE: SiteLocale = 'en'

export type SiteLocale = (typeof LOCALES)[number]

export function isValidLocale(value: string | undefined | null): value is SiteLocale {
  return value != null && (LOCALES as readonly string[]).includes(value)
}

export const LOCALE_HTML_LANG: Record<SiteLocale, string> = {
  en: 'en-GB',
  us: 'en-US',
  es: 'es',
  de: 'de',
}

export const LOCALE_HREFLANG: Record<SiteLocale, string> = {
  en: 'en-GB',
  us: 'en-US',
  es: 'es-ES',
  de: 'de-DE',
}

export const LOCALE_OG: Record<SiteLocale, string> = {
  en: 'en_GB',
  us: 'en_US',
  es: 'es_ES',
  de: 'de_DE',
}
